import styled from 'styled-components';
import { colors, smallShadow, largeShadow } from 'ui/theme';
import Card from './Card';
import { HoverCardProps } from './types';

const HoverCardStyle = styled(Card)`
  background-color: ${colors.white};
  border-radius: 6px;

  /** If box shadow is applied, minimum margins are applied so the shadow does not overlap other elements */
  ${({ hasBoxShadow }) => (hasBoxShadow ? smallShadow : ``)}
  &:hover, &:focus-within, &:focus {
    ${({ shouldHover, hasBoxShadow }) =>
      shouldHover && hasBoxShadow ? largeShadow : ``}/** not sure if there is a transform up */
  }
`;

export const HoverCard = ({
  shouldHover = true,
  hasBoxShadow = true,
  children,
  ...props
}: HoverCardProps) => {
  return (
    <HoverCardStyle
      data-test="HoverCard"
      hasBoxShadow={hasBoxShadow}
      shouldHover={shouldHover}
      {...props}
    >
      {children}
    </HoverCardStyle>
  );
};

export default HoverCard;
